<template>
    <b-navbar toggleable="lg" id='navbar-medsafe'>
        <b-container>
            <b-navbar-brand><b-img @click='goToMain' src="./dist/logo-esp.svg" fluid></b-img></b-navbar-brand>


            <b-navbar-toggle target="nav-collapse">
                
                <button 
                    class="navbar-toggler__custom collapsed" 
                    data-toggle="collapse"
                >
                        <span class="line"></span> 
                        <span class="line"></span> 
                        <span class="line"></span>
                </button>
            </b-navbar-toggle>
            <b-nav-item v-if='checked && greeting' v-html='greeting.t' :class="dashboardShow ? 'nscp' : ''" class="greet-box"></b-nav-item>
            <b-collapse id="nav-collapse" is-nav >
                <!-- <b-navbar-nav class='mx-auto' v-if='!checked || dashboardShow' >
                    <b-nav-item class='navbar__link-item' @click="scrollToAboutProject"><b>О проекте</b></b-nav-item>
                    <b-nav-item class='navbar__link-item' @click="scrollToReports"><b>Все отчеты</b></b-nav-item>
                </b-navbar-nav> -->


                <b-navbar-nav class="ml-auto">
                    <b-nav-item v-if='dashboardShow && checked' >
                        <b-button 
                            size="sm" 
                            class="my-2 my-sm-0 navbar__button"
                            @click='$router.push({ name: "dashboard", params: { id_login: id_login } })'
                        >
                            К управлению <font-awesome-icon class='navbar__icon' :icon="['fas', 'address-card']"/>
                        </b-button>

                    </b-nav-item>

                    
                    <b-nav-item v-if='!checked'>
                        <b-button 
                            size="sm" 
                            class="my-2 my-sm-0 navbar__button"
                            @click='openSignInForm'
                        >
                            Вход <font-awesome-icon class='navbar__icon' :icon="['fas', 'sign-in-alt']"/>
                        </b-button>

                    </b-nav-item>

                    <!-- <b-nav-item v-if='checked'>
                        <b-button
                            size='sm'
                            class='my-2 my-sm-0 navbar__button'
                            @click='goToBranchList'
                        >
                            Вакцинация
                        </b-button>
                    </b-nav-item> -->

                    <b-nav-item v-if='checked'>
                        <b-button
                            size='sm'
                            class='my-2 my-sm-0 navbar__button exit-button'
                            @click='endSession(); dashboardShow = false;'
                        >
                            Выход <font-awesome-icon class='navbar__icon' :icon="['fas', 'sign-out-alt']"/>
                        </b-button>
                    </b-nav-item>
                   
                    

                    
                </b-navbar-nav>
            </b-collapse>
        </b-container>
    </b-navbar>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'navbar',
    data() {
        return {
            dashboardShow: false
        }
    },
    methods: {
        scrollToReports() {
            let firstReport = document.getElementById("reports");
            firstReport.scrollIntoView({ block: "start", behavior: "smooth" });
        },
        scrollToAboutProject() {
            let text = document.getElementById("about");
            text.scrollIntoView({ block: "start", behavior: "smooth" });
        },
        openSignInForm() {
            this.$bvModal.show('sign-in')
        },
        goToMain() {
            this.$router.push({ name: 'stop-covid' })
        },
        goToBranchList() {
            this.getVaccinCovidBranches();
            this.$router.push({ name: 'referral-for-interview' });
        },
        ...mapActions('login', ['endSession']),
        ...mapActions('covid', ['getVaccinCovidBranches'])
    },
    computed: {
        ...mapState({
            checked: state => state.checked,
            greeting: state => state.greeting,
            id_login: state => state.userData.id_login
        })
    },
    watch: { 
     '$route.name': {
        handler: function(search) {
           if (search === 'dashboard' || search === 'order') {
               this.dashboardShow = false
           } else this.dashboardShow = true
        },
        deep: true,
        immediate: true
      }
}
}
</script>

<style>

#navbar-medsafe {
    background-color: #F6F6F6;
    box-shadow: 0px 4px 23px rgba(0, 0, 0, 0.35);
}
.nscp {
    display: none !important;
}

.navbar__button {
    background-color: #0D4A8E;
    border-radius: 10px;
    height: 40px;
    min-width: 70px;
    border: 1px solid  #0D4A8E;
}
.navbar__button:hover {
    background-color: #0face3;
    border: 1px solid #0face3;
}
.navbar__icon {
    vertical-align: middle;
}

.navbar__link-item a {
    color: #0D4A8E !important;
    line-height: 18px;
    letter-spacing: 0.2px;
    margin-left: 32px;
}

.navbar-toggler .line{
    width: 35px;
    float: left;
    height: 2px;
    background-color: #F2994A;
    margin-bottom: 8px;
}
.navbar-toggler {
    border: none;
    width: 70px;
    color: #F2994A;
}
.navbar-toggler__custom {
    width: 100%;
    border: none;
    background-color: transparent;
}
.navbar-dark .navbar-nav .nav-link {
    color: #fff !important
}
.greet-box {
    color: #0D4A8E;
    font-size: 0.8rem;
    list-style-type: none;
    max-width: 600px;
}
.exit-button {
    min-width: 80px;
}
@media (max-width: 992px) {
    .greet-box {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue